import { render, staticRenderFns } from "./episode-info.vue?vue&type=template&id=485b44fe&"
import script from "./episode-info.vue?vue&type=script&lang=js&"
export * from "./episode-info.vue?vue&type=script&lang=js&"
import style0 from "./episode-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports